"use client";

import React, { Component } from "react";
import { requestError, requestSuccess } from "utils/requestHandler";
import { Get, Post, Put, Delete } from "utils/axios";

const HOC = (WrappedComponent) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      profile: null,
      alertSoundRules: []
    };

    load = (param) => this.setState({ loading: param });

    getProfile = () => {
      Get(
        `/api/profile`,
        this.getProfileSuccess,
        error => requestError(error),
        this.load
      )
    }

    getProfileSuccess = payload => {
      this.setState({profile:payload.DATA})
    }

    getAlertSoundRules = () => {
      Get(
        `/api/alertsoundrules`,
        this.getAlertSoundRulesSuccess,
        error => requestError(error),
        this.load
      )
    }

    getAlertSoundRulesSuccess = payload => {
      this.setState({ alertSoundRules: payload.DATA })
    }

    addAlertSoundRule = (keyword, soundId) => {
      let payload = {
        KEYWORD: keyword,
        SOUND_ID: soundId
      }
      Post(
        `/api/alertsoundrules`,
        payload,
        this.addAlertSoundRuleSuccess,
        error => requestError(error),
        this.load
      )
    }

    addAlertSoundRuleSuccess = payload => {
      requestSuccess('Alert sound rule added successfully!')
      this.getAlertSoundRules()
    }

    updateAlertSoundRule = (ruleId, keyword, soundId, enabled) => {
      let payload = {
        KEYWORD: keyword,
        SOUND_ID: soundId,
        ENABLED: enabled
      }
      Put(
        `/api/alertsoundrules/${ruleId}`,
        payload,
        this.updateAlertSoundRuleSuccess,
        error => requestError(error),
        this.load
      )
    }

    updateAlertSoundRuleSuccess = payload => {
      requestSuccess('Alert sound rule updated successfully!')
      this.getAlertSoundRules()
    }

    deleteAlertSoundRule = (ruleId) => {
      Delete(
        `/api/alertsoundrules/${ruleId}`,
        this.deleteAlertSoundRuleSuccess,
        error => requestError(error),
        this.load
      )
    }

    deleteAlertSoundRuleSuccess = payload => {
      requestSuccess('Alert sound rule deleted successfully!')
      this.getAlertSoundRules()
    }

    render = () => {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          getProfile={this.getProfile}
          getAlertSoundRules={this.getAlertSoundRules}
          addAlertSoundRule={this.addAlertSoundRule}
          updateAlertSoundRule={this.updateAlertSoundRule}
          deleteAlertSoundRule={this.deleteAlertSoundRule}
          onLoading={this.state.loading}
        />
      );
    };
  }
  return WithHOC;
};

export default HOC;
